import { AccountType, AccountStatus, MessageTag, UserTag } from './status.js';

const AccountTypeLabel = {
    [AccountType.USER]: 'User',
    [AccountType.MODERATOR]: 'Moderator',
    [AccountType.ADMIN]: 'Admin',
    [AccountType.SUPERADMIN]: 'SuperAdmin',
};

const AccountStatusLabel = {
    [AccountStatus.ACTIVE]: 'Active',
    [AccountStatus.INACTIVE]: 'Inactive',
    [AccountStatus.BLOCKED]: 'Blocked',
    [AccountStatus.EMAIL_NOT_VERIFIED]: 'EmailNotVerified',
};

const MessageTagLabel = {
    [MessageTag.UNREAD]: 'unread',
    [MessageTag.EXPIRING]: 'expiring',
};

const UserTagLabel = {
    [UserTag.NONE]: '',
    [UserTag.NEW]: 'New',
    [UserTag.TRENDING]: 'Trending',
};

export { AccountStatusLabel, AccountTypeLabel, MessageTagLabel, UserTagLabel };
